import { isMobileOrTablet } from "Utils/DeviceDetectHelpers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "redirect",
  onEnter: (nextState, replace) => {
    const queryString = nextState.location.search || "";
    if (!isMobileOrTablet()) {
      // Desktop users: proceed to normal web navigation with original query params
      replace(`/${queryString}`);
    }
    // Mobile users: fall through and render MobileUnsupportedView
  },
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
